@import '~style-sheet-helpers/core.less';
@import '../../app-brand/entities/entity-layer.module.less';

.shipment-details-container {
  width: 100%;
  background-color: @shipment-details--background-color;
}

.shipment-columns {
  display: flex;
}

.shipment-details-column {
  padding: 15px;
  width: 50%;
}

.shipment-details-column:first-child {
  border-right: 1px solid @shipment-details--first-column--border-color;
}

.shipment-details-options {
  padding: 5px 15px 15px;
  border-top: 1px solid @shipment-details--options--border-color;
  font-size: 14px;

  label {
    font-size: 10px;
    color: @shipment-details--options--text-color;
    padding-top: 10px;
  }

  .shipping-options-label {
    height: 50px;
  }
}
